import { render } from "./SenderEmailInstructionsModal.vue?vue&type=template&id=6e1d914a&ts=true"
import script from "./SenderEmailInstructionsModal.vue?vue&type=script&lang=ts"
export * from "./SenderEmailInstructionsModal.vue?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./SenderEmailInstructionsModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__